import { SDKError } from "@smash-sdk/core";
export class GenericError extends SDKError {
}
export class InvalidAvailabilityDurationError extends GenericError {
    constructor() {
        super(...arguments);
        this.name = "InvalidAvailabilityDurationError";
    }
}
export class InvalidParameterError extends GenericError {
    constructor() {
        super(...arguments);
        this.name = "InvalidParameterError";
    }
}
export class UnauthorizedError extends GenericError {
    constructor() {
        super(...arguments);
        this.name = "UnauthorizedError";
    }
}
export class InvalidSubscriptionError extends GenericError {
    constructor() {
        super(...arguments);
        this.name = "InvalidSubscriptionError";
    }
}
export class EmailNotAllowedError extends GenericError {
    constructor() {
        super(...arguments);
        this.name = "EmailNotAllowedError";
    }
}
export class UsageExceededError extends GenericError {
    constructor() {
        super(...arguments);
        this.name = "UsageExceededError";
    }
}
export class PasswordRequiredError extends GenericError {
    constructor() {
        super(...arguments);
        this.name = "PasswordRequiredError";
    }
}
export class ForbiddenError extends GenericError {
    constructor() {
        super(...arguments);
        this.name = "ForbiddenError";
    }
}
export class NotFoundError extends GenericError {
    constructor() {
        super(...arguments);
        this.name = "NotFoundError";
    }
}
export class CustomUrlAlreadyInUseError extends GenericError {
    constructor() {
        super(...arguments);
        this.name = "CustomUrlAlreadyInUseError";
    }
}
export class InternalServerError extends GenericError {
    constructor() {
        super(...arguments);
        this.name = "InternalServerError";
    }
}
export class BadGatewayError extends GenericError {
    constructor() {
        super(...arguments);
        this.name = "BadGatewayError";
    }
}
export class GatewayTimeoutError extends GenericError {
    constructor() {
        super(...arguments);
        this.name = "GatewayTimeoutError";
    }
}
export default {
    GenericError,
    InvalidAvailabilityDurationError,
    InvalidParameterError,
    UnauthorizedError,
    InvalidSubscriptionError,
    EmailNotAllowedError,
    UsageExceededError,
    PasswordRequiredError,
    ForbiddenError,
    NotFoundError,
    CustomUrlAlreadyInUseError,
    InternalServerError,
    BadGatewayError,
    GatewayTimeoutError,
};
